module.exports = __webpack_public_path__ + "img/like-h.d04ae67c.png";